// Index of path keyword into URL
import {LocalStoreType} from "./lib/types/types";

export const TEMPLATES_FORMAT_INDEX_IN_PATH: number = 0;
export const TEMPLATES_CATEGORY_INDEX_IN_PATH: number = 1;

export const STORY_TYPE_STATIC: number = 0;
export const STORY_TYPE_ANIMATED: number = 1;


// Sizes
export const NAVBAR_HEIGHT = '61px';

// Assets
// Application static assets URLs
export const SIMPLIFIED_ASSETS_BASE_URL = "https://assets.simplified.co";
export const DASHBOARD_BANNER = `${SIMPLIFIED_ASSETS_BASE_URL}/images/dashboard-banner.png`;

// Redux store
export const STORE_LOCAL_STORAGE_KEY: string = "store";
export const POST_LOGIN_STORAGE_KEY: string = "postLogin";
export const TOKEN_STORAGE_KEY: string = "Token";
export const INITIAL_STORE: LocalStoreType = {
  auth: {
    isAuthenticated: false,
    payload: {}
  },
  plannerStore: {
    eventsCategories: {
      categories: [],
      selected: ["1"]
    }
  },
  socialAccountsStore: {
    accounts: [],
    selected: [],
    selectedSingle: null,
    selectedForDrafts: []
  }
}

// Post login action
export const POST_LOGIN_CLONE_TEMPLATE = "clone_template";
export const POST_LOGIN_CREATE_STORY = "create_story"

export const MAIN_CONTAINER_SCROLLABLE_TARGET_ID: string =
  "infinite-scroll-main-container";

export const PROMISE_CALL_FULFILLED = "fulfilled";
export const PROMISE_CALL_REJECTED = "rejected";

export const SIMPLIFIED_ACADEMY_LINK = "https://simplified.co/academy";
export const SIMPLIFIED_OFFICIAL_COMMUNITY_LINK =
  "https://www.facebook.com/groups/simplifiedcommunity/";
export const SIMPLIFIED_HELP_CENTRE_LINK = "https://help.simplified.co/";

export const REGISTER_FORM_SIGN_UP = 'sign-up';
export const REGISTER_FORM_SIGN_IN = 'sign-in';
